import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Globe, Check } from 'lucide-react';

// Flag images using flag CDN
const flagImages = {
  en: 'https://flagcdn.com/w40/us.png',
  pt: 'https://flagcdn.com/w40/br.png',
  es: 'https://flagcdn.com/w40/es.png'
};

export const LanguageSelector = () => {
  const { language, setLanguage, languages } = useLanguage();

  const currentLang = languages.find(l => l.code === language);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger 
        className="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-muted transition-colors" 
        data-testid="language-selector"
      >
        <Globe className="w-4 h-4" />
        <img 
          src={flagImages[language]} 
          alt={currentLang?.name}
          className="w-6 h-4 object-cover rounded shadow-sm"
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className={`flex items-center gap-3 cursor-pointer ${
              language === lang.code ? 'bg-muted' : ''
            }`}
            data-testid={`lang-${lang.code}`}
          >
            <img 
              src={flagImages[lang.code]} 
              alt={lang.name}
              className="w-6 h-4 object-cover rounded shadow-sm"
            />
            <span className="flex-1">{lang.name}</span>
            {language === lang.code && (
              <Check className="w-4 h-4 text-primary" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
